import z from 'zod'

import { LocationTypes, LocationTypesZ, WithName } from './common'
import { HotelSearchResult } from './hotel'
import { User } from './user'

export const LocationZ = z.object({
	id: z.string().or(z.number()).nullable(),
	external_id: z.string().nullable().optional(),
	name: z.string(),
	location_type: LocationTypesZ,
})

export interface Airport {
	name: string
	code: string
	city_code: string
	longitude: number
	country_iso: string
	latitude: number
	id: number
	type: LocationTypes.Airport
}

export interface Office {
	address: string
	name: string
	id: string
	type: LocationTypes.Office
	latitude?: number
	longitude?: number
}

export interface Station {
	id: string
	external_id: string | null
	number: number
	name_local: string
	name_en: string | null
	type: LocationTypes.Rail | LocationTypes.AllStation
	latitude?: number
	longitude?: number
	country?: string
	country_name?: string
}

export interface City {
	id: number
	city: string
	state: string | null
	country: string
	airports: Airport[]
	stations: Station[]
	offices: Office[]
	type: LocationTypes.City
	iata_code?: string
	state_code?: string | null
	latitude: number
	longitude: number
}
export interface WorldPoint {
	lat: number | null
	long: number | null
}

export type LocationId = string | number

export type ExternalLocationId = string

export interface Location extends WorldPoint, WithName {
	id: LocationId | null
	external_id?: ExternalLocationId | null
	address: string
	location_data:
		| google.maps.places.PlaceResult
		| google.maps.places.AutocompletePrediction
		| { city_code?: string; iata?: string }
		| HotelSearchResult
		| null
	location_type: LocationTypes
	description: string | null
	main_contact_name: string | null
	main_contact_email: string | null
	main_contact_phone: string | null
	main_approver: User | null
	created_dt?: string
	visibility?: 'private' | 'public' | 'hidden'
	short_name?: string | null
	airport_name?: string | null
	// NOTE: For rails `country?: { code: string; name: string }` but not for hotels
	country?: string
	country_name?: string
	country_code?: string
	city_name?: string
	city_code?: string
	iata_code?: string
	code?: string
	state_name?: string
	has_policy?: boolean
	group_id?: number
	number?: number
	users_count?: number
	state_code: string | null
}

export type LongitudeLatitude = { lng: number; lat: number }

export type FitBounds = [[number, number], [number, number]]

export interface LongitudeLatitudeBounds {
	getSouthWest: () => LongitudeLatitude
	getNorthEast: () => LongitudeLatitude
}

export interface OfficeJson {
	id: LocationId | null
	name: string
	address: string
	created_dt?: string
	office_type: LocationTypes
	country_code?: string
	city_name?: string
	state_name?: string
	description: string | null
	contact_name: string | null
	contact_email: string | null
	contact_phone: string | null
	office_approver?: User | null
	office_approver_id?: number | null
	latitude: number | null
	longitude: number | null
	group_id?: number
	has_policy?: boolean
	users_count?: number
}
